var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props),
    React.createElement("path", { className: styles["oc-icon-light-gray"] || "oc-icon-light-gray", d: "M15 0a15 15 0 1 0 15 15A15 15 0 0 0 15 0zm1.8 23.7h-3.6V11.6h3.6zM15 10.5a2.1 2.1 0 1 1 2.1-2.1 2.1 2.1 0 0 1-2.1 2.1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Info.svg